export default __webpack_public_path__ + "static/media/benefit_1@2x.8236363b.png";